import { getCookie } from "cookies-next";
import { getFirebaseAuth } from "../firebase";
import { getRandomID } from "../js_helpers";

export function getSessionId(): string {
  const key = 'sessionId';
  let sessionId = sessionStorage.getItem(key);

  if (!sessionId) {
    sessionId = getRandomID(16);
    sessionStorage.setItem(key, sessionId);
  }

  return sessionId;
}

export function getDeviceId(): string {
  const cookieDeviceId = getCookie('device_id');
  return cookieDeviceId as string
}

export function getUUID(): string | undefined {
  // Note: this still constructs the Auth SDK on first call if nothing has
  // touched it yet (e.g. an analytics event fires before the idle-deferred
  // check in authUserContext) — unavoidable since the UID has to come from
  // somewhere. The fix in lib/firebase.ts targets the guaranteed-eager path
  // (every page's header), not every possible early caller.
  if (getFirebaseAuth().currentUser?.uid) {
    return getFirebaseAuth().currentUser!.uid;
  }
  return ''
}

export const getZonePreference = () => {
  const zonePreference = getCookie('zone_preference');
  if (zonePreference) {
    try {
      return JSON.parse(zonePreference as string);
    } catch (error) {
      console.error('Error parsing zone preference cookie:', error);
    }
  }
  return null;
}